import React, { useState } from 'react';
import { message } from 'antd';

const DeliveryModal = ({ onClose, onSubmit, getCoordinates }) => {
  const [formData, setFormData] = useState({
    name: '', location: '', weight: '', priority: 'medium', timeStart: '', timeEnd: '', latitude: '', longitude: ''
  });
  const [isGeocoding, setIsGeocoding] = useState(false);

  const handleLocationBlur = async () => {
    if (!formData.location) return;
    setIsGeocoding(true);
    const coords = await getCoordinates(formData.location, () => {});
    if (coords) {
      setFormData(prev => ({ ...prev, latitude: coords.latitude, longitude: coords.longitude }));
    }
    setIsGeocoding(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (parseInt(formData.timeEnd) <= parseInt(formData.timeStart)) {
      message.warning('End time must be after start time!');
      return;
    }
    if (!formData.latitude || !formData.longitude) {
      message.warning("Please enter a valid location and wait for coordinates to auto-fill.");
      return;
    }
    onSubmit({
      ...formData,
      weight: parseInt(formData.weight),
      timeStart: parseInt(formData.timeStart),
      timeEnd: parseInt(formData.timeEnd)
    });
  };

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ display: 'block', position: 'fixed', zIndex: 1000, left: 0, top: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)' }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', margin: '5% auto', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '500px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #f3f4f6' }}>
          <h3 style={{ fontSize: '20px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Add Delivery</h3>
          <span onClick={onClose} style={{ color: '#9ca3af', fontSize: '28px', fontWeight: 'bold', cursor: 'pointer' }}>&times;</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Customer Name</label>
            <input type="text" required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="e.g., Priya Distributors"
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>
              Location
              <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '5px' }}>(e.g., "Privilon Building, Iscon Cross Road, Ahmedabad")</span>
            </label>
            <input type="text" required value={formData.location} onChange={e => setFormData({ ...formData, location: e.target.value })}
              onBlur={handleLocationBlur} placeholder="Building, Street, City"
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
            {isGeocoding && (
              <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#667eea' }}>
                <div className="spinner" style={{ width: '14px', height: '14px', border: '2px solid rgba(0,0,0,0.1)', borderTopColor: '#667eea', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                Fetching coordinates...
              </div>
            )}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Latitude</label>
              <input type="text" readOnly value={formData.latitude} placeholder="Auto-filled"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#f3f4f6' }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Longitude</label>
              <input type="text" readOnly value={formData.longitude} placeholder="Auto-filled"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#f3f4f6' }} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Weight (kg)</label>
              <input type="number" required min="1" value={formData.weight} onChange={e => setFormData({ ...formData, weight: e.target.value })} placeholder="150"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Priority</label>
              <select required value={formData.priority} onChange={e => setFormData({ ...formData, priority: e.target.value })}
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }}>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
              </select>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Time Start</label>
              <input type="number" required min="0" max="23" value={formData.timeStart} onChange={e => setFormData({ ...formData, timeStart: e.target.value })} placeholder="9"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Time End</label>
              <input type="number" required min="1" max="24" value={formData.timeEnd} onChange={e => setFormData({ ...formData, timeEnd: e.target.value })} placeholder="12"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" disabled={!formData.latitude || !formData.longitude} style={{
              flex: 1, padding: '12px', background: (!formData.latitude || !formData.longitude) ? '#9ca3af' : '#667eea', color: 'white', border: 'none', borderRadius: '8px',
              cursor: (!formData.latitude || !formData.longitude) ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: 500
            }}>Add Delivery</button>
            <button type="button" onClick={onClose} style={{ padding: '12px 20px', background: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeliveryModal;
